const maxDate = "9999-12-31T23:59:59.999999";

function isInvalidOrMaxDate(datetime) {
    return !datetime || datetime === maxDate;
}

export function convertDateStringToDateTime(datestring) {
    if (isInvalidOrMaxDate(datestring)) {
        return "";
    }

    const date = new Date(datestring);

    const datetime = date.getFullYear() + "-" +
        String(date.getMonth() + 1).padStart(2, "0") + "-" +
        String(date.getDate()).padStart(2, "0") + "T00:00:00.000";

    return datetime;
}

export function convertDateTimeToDateString(datetime) {
    if (isInvalidOrMaxDate(datetime)) {
        return "";
    }

    const date = new Date(datetime).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
    return date; // "15/10/2025" or "10/15/2025" based on locale
}

// Converts a datetime string to an input date string (YYYY-MM-DD)
export function convertDateTimeToInputDateString(datetime) {
    if (isInvalidOrMaxDate(datetime)) {
        return "";
    }

    // If already in YYYY-MM-DD, return as is
    if (/^\d{4}-\d{2}-\d{2}$/.test(datetime)) {
        return datetime;
    }

    const date = new Date(datetime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}

export function handleDisplayCreatedOnOrUpdatedOn(createdOn, updatedOn) {
    if (updatedOn === maxDate) {
        return createdOn
    }
    else {
        return updatedOn;
    }
}

export function handleUpdatedOnConversion(datetime) {
    if (isInvalidOrMaxDate(datetime)) {
        return "";
    }
    else {
        return convertDateTimeToDateString(datetime);
    }
}